import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "@/data/site";
import { PageHero } from "@/components/PageHero";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { QuoteForm } from "@/components/QuoteForm";

export default function Contact() {
  return (
    <>
      <PageHero
        label="Contact"
        title="Request Your Free Quote"
        subtitle="Get in touch for honest advice and a free, no-obligation quote. Our team is ready to help with your air conditioning, electrical or heat pump hot water project."
        crumbs={[{ label: "Contact" }]}
      />

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[1fr_1.1fr] lg:gap-16 lg:px-8">
          {/* Info */}
          <Reveal>
            <SectionLabel>Get in touch</SectionLabel>
            <h2 className="mt-5 font-display text-3xl md:text-4xl font-bold tracking-tight text-brand-blue">
              We'd love to hear from you
            </h2>

            <div className="mt-8 space-y-5">
              <a href={BUSINESS.phoneHref} data-testid="contact-phone" className="flex items-start gap-4 group">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-electric/10"><Phone className="h-5 w-5 text-brand-electric" /></span>
                <div>
                  <div className="text-sm text-slate-500">Phone</div>
                  <div className="font-medium text-brand-blue group-hover:text-brand-electric transition-colors">{BUSINESS.phone}</div>
                </div>
              </a>
              <a href={BUSINESS.emailHref} data-testid="contact-email" className="flex items-start gap-4 group">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-electric/10"><Mail className="h-5 w-5 text-brand-electric" /></span>
                <div>
                  <div className="text-sm text-slate-500">Email</div>
                  <div className="font-medium text-brand-blue break-all group-hover:text-brand-electric transition-colors">{BUSINESS.email}</div>
                </div>
              </a>
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-electric/10"><Clock className="h-5 w-5 text-brand-electric" /></span>
                <div>
                  <div className="text-sm text-slate-500">ABN</div>
                  <div className="font-medium text-brand-blue">{BUSINESS.abn}</div>
                </div>
              </div>
            </div>

            <div className="mt-8 space-y-4">
              {BUSINESS.offices.map((o) => (
                <div key={o.address} className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-[#FAFAFA] p-5">
                  <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" />
                  <div>
                    <div className="text-sm font-semibold text-brand-blue">{o.label}</div>
                    <div className="text-[15px] text-slate-600">{o.address}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 overflow-hidden rounded-2xl border border-slate-200">
              <iframe
                title="Access Electrical head office location"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=Suite%20535%2F1%20Queens%20Rd%2C%20Melbourne%20VIC%203004&output=embed"
                width="100%"
                height="280"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>

          {/* Form */}
          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-slate-200 bg-[#FAFAFA] p-6 md:p-8">
              <h3 className="font-display text-2xl font-semibold text-brand-blue">Send us an enquiry</h3>
              <p className="mt-2 text-slate-600">We typically respond within one business day.</p>
              <div className="mt-6">
                <QuoteForm />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
